/**
 * Feature flags for enabling/disabling major application features
 */

/**
 * Controls the entire commitment pledges feature across the application.
 * When set to false, this will:
 * - Hide the "Commitment Pledges" section in Settings
 * - Hide the donation badge (💝 $X donated) from all user profiles
 * - Remove the commitment pledges tutorial slide from the onboarding sequence
 * - Remove the accountability screen from the loading screen
 * 
 * Set to true to enable all commitment pledge features.
 * Set to false to completely disable the feature.
 */
export const ENABLE_COMMITMENT_PLEDGES = false;
